// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChartTooltipGroupedIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ChartTooltipGroupedIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M8 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      <path d="M7 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
      <path d="M4 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm.5 1.5h11v9h-11z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ChartTooltipGroupedIcon = /* @__PURE__ */ Object.assign(
  ChartTooltipGroupedIconComponent,
  { displayName: 'ChartTooltipGroupedIcon' },
);
